import { render, staticRenderFns } from "./Referenz.vue?vue&type=template&id=1a0ab18a&scoped=true&"
import script from "./Referenz.vue?vue&type=script&lang=js&"
export * from "./Referenz.vue?vue&type=script&lang=js&"
import style0 from "./Referenz.vue?vue&type=style&index=0&id=1a0ab18a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ab18a",
  null
  
)

export default component.exports